"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUiInformation = exports.getDeviceUUID = exports.initDeviceUUID = void 0;
const init_1 = require("../mobileConnector/init");
const useUiInformationBase_1 = require("../uiInformation/useUiInformationBase");
var features_1 = require("../features");
Object.defineProperty(exports, "initDeviceUUID", { enumerable: true, get: function () { return features_1.initDeviceUUID; } });
Object.defineProperty(exports, "getDeviceUUID", { enumerable: true, get: function () { return features_1.getDeviceUUID; } });
const useUiInformation = () => {
    return (0, useUiInformationBase_1.useUiInformationBase)(init_1.mobileConnector);
};
exports.useUiInformation = useUiInformation;
//# sourceMappingURL=index.js.map